import { useContext } from 'react';
import { HubThemingContext } from './HubThemingContext';

export const useHubTheming = () => {
  const context = useContext(HubThemingContext);

  if (context === null) {
    throw new Error('useHubTheming must be used within a HubThemingProvider');
  }

  return context;
};
